import { ReactElement } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { ContentLabelField, TextField } from '@hopskipdrive/react-components';
import * as Yup from 'yup';

interface DescriptionFieldProps {
  defaultValue?: string;
}

export const descriptionValidation = Yup.string().required('Description is required').default('');

export const DescriptionField = ({ defaultValue }: DescriptionFieldProps): ReactElement => {
  const { control } = useFormContext();
  const { field, fieldState } = useController({
    name: 'description',
    control,
    defaultValue: defaultValue || null,
  });

  return (
    <ContentLabelField
      id="description"
      title="Description"
      editMode={true}
      required={true}
      editView={
        <TextField
          variant="outlined"
          placeholder="Add a description of what happened in this incident"
          fullWidth
          multiline={true}
          rows={5}
          value={field.value}
          onChange={field.onChange}
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
        />
      }
    />
  );
};
